import React from "react";
import { VStack } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import AudienceListItem from "../../AudienceListItem";
import { SocialIcon, LookalikeIcon } from "../../AudienceIcons";
import { StepProps, PageLookalikeAudienceFormValues } from "../types";

const AudienceTypeStep: React.FC<StepProps> = () => {
  const form = useFormContext<PageLookalikeAudienceFormValues>();
  const audienceMode = form.watch("audienceMode");
  const hasFacebookSelection = Boolean(form.watch("facebookPageId"));
  const hasInstagramSelection = Boolean(form.watch("instagramPageId"));

  const pageAudienceDescription = hasFacebookSelection && hasInstagramSelection
    ? "Reach people who engaged with your Facebook page and Instagram account"
    : hasInstagramSelection
      ? "Reach people who engaged with your Instagram account"
      : hasFacebookSelection
        ? "Reach people who engaged with your Facebook page"
        : "Reach people who engaged with your Facebook page or Instagram account";

  const options = [
    {
      title: "Create page audience",
      description: pageAudienceDescription,
      value: "engagers" as const,
      icon: <SocialIcon />,
      iconBgColor: "#DFEAFD",
      isRecommended: true,
    },
    {
      title: "Create lookalike audience",
      description:
        "Reach new people who are similar to your existing followers",
      value: "lookalike" as const,
      icon: <LookalikeIcon />,
      iconBgColor: "#FDF5DF",
      isRecommended: false,
    },
  ];

  return (
    <VStack spacing={3} align="stretch">
      {options.map((option) => (
        <AudienceListItem
          key={option.value}
          title={option.title}
          description={option.description}
          icon={option.icon}
          iconBgColor={option.iconBgColor}
          value={option.value}
          isSelected={audienceMode === option.value}
          onSelect={(value) => form.setValue("audienceMode", value)}
          isRecommended={option.isRecommended}
          showRadio={true}
          showPlus={false}
        />
      ))}
    </VStack>
  );
};

export default AudienceTypeStep;
